import React from "react";
import _ from "lodash";

import useMounted from "./useMounted";

const useFetch = <T>(
  service: any,
  method: string,
  params: any[] | null = null,
  condition = true
): [T, boolean, any, any] => {
  const isMounted = useMounted();

  params = !params?.length ? null : params;

  const [data, setData] = React.useState<any>();
  const [error, setError] = React.useState<any>();
  const [loading, setLoading] = React.useState<boolean>(true);

  const paramsRef = React.useRef<any[]>();

  React.useEffect(() => {
    setError(null);

    const fetchData = (): void => {
      setLoading(true);

      const call = params?.length
        ? service[method](...params)
        : service[method]();

      call
        .then((_data: any) => {
          isMounted.current && setData(_data);
        })
        .catch((_error: any) => {
          isMounted.current && setError(_error);
        })
        .finally(() => {
          isMounted.current && setLoading(false);
        });
    };

    /**
     * Deep check to see if params are different
     */
    if (params) {
      const paramsDifference = _(params)
        .differenceWith(paramsRef?.current || [], _.isEqual)
        .isEmpty();

      if (!paramsDifference) {
        paramsRef.current = params;
        condition && fetchData();
      }
    } else {
      condition && fetchData();
    }
  }, [isMounted, condition, method, service, params]);

  return [data, loading, error, setData];
};

export default useFetch;
